import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import About from '../components/About';
const Nosotros = () => {
  return <div className="flex flex-col min-h-screen w-full" data-id="element-264">
      <Header data-id="element-265" />
      <main data-id="element-266">
        <About data-id="element-267" />
      </main>
      <Footer data-id="element-268" />
    </div>;
};
export default Nosotros;